import React from 'react';
import styled from 'styled-components';
import { Colors } from '../patterns/Colors';

export const LegalFooter = () => {
    return <Footer>
        By signing up, you acknowledge that you have read, and agree to our{' '}
        <FootLink href="https://spreo.io/terms" target="_blank">Terms of Service</FootLink>
        {' '}and our{' '}
        <FootLink href="https://spreo.io/privacy" target="_blank">Privacy Policy</FootLink>.
    </Footer>;
};

const Footer = styled.div`
    font-size: 0.75rem;
    color: ${Colors.text};
    line-height: 1.5;
    padding-top: 1rem;
    margin-top: auto;
`;

const FootLink = styled.a`
    color: ${Colors.primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
